var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03848 0.9L3.03836 0.9C2.45105 0.900704 1.888 1.13432 1.47271 1.54961C1.05742 1.9649 0.823799 2.52796 0.823096 3.11526V3.11538V20.8846C0.823096 22.1058 1.81638 23.1 3.03848 23.1H10.6539C11.876 23.1 12.8693 22.1058 12.8693 20.8846V3.11538C12.8693 1.89418 11.876 0.9 10.6539 0.9L3.03848 0.9ZM3.03848 1.94615H10.6539C11.2984 1.94615 11.8231 2.47084 11.8231 3.11538V4.28462H1.86925V3.11538C1.86925 2.47084 2.39394 1.94615 3.03848 1.94615ZM11.8231 17.8231H1.86925V5.33077H11.8231V17.8231ZM10.6539 22.0538H3.03848C2.39394 22.0538 1.86925 21.5292 1.86925 20.8846V18.8692H11.8231V20.8846C11.8231 21.5292 11.2984 22.0538 10.6539 22.0538Z",
    fill: "url(#paint0_linear_6741_7770)",
    stroke: "url(#paint1_linear_6741_7770)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6741_7770",
    x1: 6.61632,
    y1: -7.70833,
    x2: 6.61639,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAA52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6741_7770",
    x1: 6.84617,
    y1: 1,
    x2: 6.84617,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAA52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMob);
export default __webpack_public_path__ + "static/media/mob.bb6d67aa8622afce8e28804270bef60d.svg";
export { ForwardRef as ReactComponent };